import { Col, TableColumnType } from "antd";
import moment from "moment";
import React, { ReactElement } from "react";
import { DateTimeFormatSimple } from "../../../../models/datetime";
import { Material } from "../../../../models/material";
import { ThemeData } from "../../../../theme/ThemeContext";
import styles from "./columns.module.css";

export const RecipeItemColumns = (
  theme: ThemeData
): TableColumnType<Material>[] => {
  return [
    {
      title: "药品信息",
      key: "name",
      className: styles.name,
      render: function MaterialName(_, m): ReactElement {
        return (
          <Col>
            <div
              style={{
                color: theme.tc1,
                width: 220,
                fontSize: "1.125rem",
                fontWeight: "bold",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {m.name}
            </div>
            <div
              style={{
                color: theme.tc3,
                width: 220,
                fontSize: "1rem",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {m.packSpec}/{m.accountUnit}/{m.doseCategory}/
              {m.tenantSupplierName}
            </div>
          </Col>
        );
      },
    },
    {
      title: "库房",
      dataIndex: "storehouseName",
      align: "center",
    },
    {
      title: "库存",
      key: "count",
      align: "center",
      render: (_, m) => `${m.count}${m.accountUnit}`,
    },
    {
      title: "拆零",
      key: "split",
      align: "center",
      render: (_, m) => (m.splitTag === 1 ? m.splitScale : "/"),
    },
    { title: "单价/元", dataIndex: "retailPrice", align: "right" },
    { title: "备注", key: "remark", align: "center" },
  ];
};

export const RecipeItemColumnsWithBatchNo = (
  theme: ThemeData
): TableColumnType<Material>[] => {
  return [
    {
      title: "药品信息",
      key: "name",
      className: styles.name,
      render: function MaterialName(_, m): ReactElement {
        return (
          <Col>
            <div
              style={{
                color: theme.tc1,
                fontSize: "1.125rem",
                fontWeight: "bold",
                whiteSpace: "nowrap",
              }}
            >
              {m.name}
            </div>
            <div
              style={{
                color: theme.tc2,
                fontSize: "1rem",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                maxWidth: 220,
              }}
            >
              {m.packSpec}/{m.accountUnit}/{m.doseCategory}/
              {m.tenantSupplierName}
            </div>
          </Col>
        );
      },
    },
    {
      title: "批次/有效期至",
      key: "batch",
      render: function Batch(_, m): ReactElement {
        const deadline = moment(m.deadline);
        const duration = moment.duration(deadline.diff(moment()));
        const warning = deadline.isValid() && duration.asDays() <= 90;
        return (
          <Col>
            <div
              style={{
                color: theme.tc1,
                fontSize: "1rem",
                whiteSpace: "nowrap",
              }}
            >
              批次号：{m.batchNo}
            </div>
            <div
              style={{
                color: warning ? theme.e : theme.tc1,
                fontWeight: warning ? "bold" : "normal",
                fontSize: "1rem",
              }}
            >
              {warning
                ? `有效期: ${Math.floor(duration.asDays())}天`
                : `有效期至：${
                    deadline.isValid()
                      ? deadline.format(DateTimeFormatSimple)
                      : "--"
                  }`}
            </div>
          </Col>
        );
      },
    },
    {
      title: "库房",
      dataIndex: "storehouseName",
      align: "center",
    },
    {
      title: "库存",
      key: "count",
      align: "center",
      render: (_, m) => `${m.count}${m.accountUnit}`,
    },
    {
      title: "拆零",
      key: "split",
      align: "center",
      render: (_, m) => (m.splitTag === 1 ? m.splitScale : "/"),
    },
    { title: "单价/元", dataIndex: "retailPrice", align: "center" },
    { title: "备注", key: "remark", align: "center" },
  ];
};

export const RecipeItemColumnsSimple = (
  theme: ThemeData
): TableColumnType<Material>[] => {
  return [
    {
      title: "药品信息",
      key: "name",
      className: styles.name,
      render: function MaterialName(_, m): ReactElement {
        return (
          <Col>
            <div
              style={{
                color: theme.tc1,
                fontSize: "1.125rem",
                fontWeight: "bold",
              }}
            >
              {m.name}
            </div>
            <div
              style={{
                color: theme.tc2,
                fontSize: "1rem",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {m.packSpec}/{m.accountUnit}/{m.doseCategory}/
              {m.tenantSupplierName}
            </div>
          </Col>
        );
      },
    },
    {
      title: "单价/元",
      dataIndex: "retailPrice",
      align: "right",
    },
    { title: "备注", key: "remark" },
  ];
};
